/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'

import {
  QueryRequestProvider,
  useQueryRequest,
} from '@/app/modules/report-trend-analysis/core/QueryRequestProvider'
import {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponseLoading,
} from '@/app/modules/report-trend-analysis/core/QueryResponseProvider'
import {PageTitle} from '../../../../_metronic/layout/core'
import {DashboardScoreCards} from './components/DashboardScoreCards'
import {SalesByMonthlyChart} from './components/SalesByMonthlyChart'
import {SalesByOutletChart} from './components/SalesByOutletChart'
import {TopQueryRequestProvider} from './core/QueryRequestTopProvider'
import {
  OutletQueryResponseProvider,
  useOutletQueryResponseData,
  useOutletQueryResponseLoading,
} from './core/QueryResponseOutletProvider'
import {useAuth} from '@/app/modules/auth'

const DashboardPage: FC = () => {
  const {updateState} = useQueryRequest()
  const {currentUser} = useAuth()
  const data = useQueryResponseData()
  const response = useQueryResponse()
  const isLoading = useQueryResponseLoading()
  const outletData = useOutletQueryResponseData()
  const outletLoading = useOutletQueryResponseLoading()

  useEffect(() => {
    updateState({month: []})
  }, [updateState])

  const noResult = (response?.response?.response as string) === 'no result data'

  return (
    <>
      {['72b0ad30-d847-47bc-af21-80f0eddca117'].includes(
        currentUser?.detail_data?.job?.job_id as string
      ) ? (
        <div className='g-5 w-100 h-100 text-center fs-1 text-primary fw-bold'>
          Welcome Back, {currentUser?.detail_data?.fullname}
        </div>
      ) : (
        <>
          <DashboardScoreCards
            revenue={data?.summary_trend?.sales ?? 0}
            transaction={data?.summary_trend?.transaction ?? 0}
            item={data?.summary_trend?.product ?? 0}
            customer={0}
            isLoading={isLoading}
          />

          <div className='row g-5 g-xl-5 mb-5 mb-xl-10'>
            <SalesByMonthlyChart
              trendTransaction={data?.trend_transaction ?? null}
              trendProduct={data?.trend_product ?? null}
              summarySales={data?.summary_trend?.sales ?? 0}
              summaryTransaction={data?.summary_trend?.transaction ?? 0}
              summaryProduct={data?.summary_trend?.product ?? 0}
              isLoading={isLoading}
              noResult={noResult}
            />

            <SalesByOutletChart outletData={outletData ?? null} isLoading={outletLoading} />
          </div>
        </>
      )}
    </>
  )
}
const DashboardWrapper: FC = () => (
  <>
    <QueryRequestProvider>
      <TopQueryRequestProvider>
        <QueryResponseProvider>
          <OutletQueryResponseProvider>
            <PageTitle breadcrumbs={[]}>Dashboard</PageTitle>
            <DashboardPage />
          </OutletQueryResponseProvider>
        </QueryResponseProvider>
      </TopQueryRequestProvider>
    </QueryRequestProvider>
  </>
)

export {DashboardWrapper}
